export default "__VITE_ASSET__lbzss2nG__"